import React from "react";
import { Link } from "gatsby";
import ImageG from "./image-g";
import { cn, getUrl } from "../lib/helpers";

import * as styles from "../styles/components/product-item.module.css";

interface Slug {
  current?: string;
}

interface ImageAsset {
  asset?: {
    _id: string;
  };
  alt?: string;
}

interface LpSettings {
  image?: ImageAsset;
  specs?: {
    applications?: string;
    colorTemperature?: string;
    optical?: string;
    lumenOutput?: string;
  };
}

interface Series {
  title?: string;
  slug?: Slug;
}

interface Product {
  id?: string;
  title?: string;
  slug?: Slug;
  lp?: LpSettings;
  series?: Series;
}

interface ProductItemProps {
  item?: Product;
}

const ProductItem: React.FC<ProductItemProps> = ({ item }) => {
  // Destructure your data for easier access
  const { title, slug, series, lp } = item || {};
  if (!slug || !slug.current) return null;

  const { image, specs } = lp || {};
  const { applications, colorTemperature, optical, lumenOutput } = specs || {};

  return (
    <div className={cn("col-md-6", styles.root)}>
      {image?.asset && (
        <div className={styles.image}>
          <Link to={getUrl(slug, "products")}>
            <ImageG node={image} />
          </Link>
        </div>
      )}

      <div className={styles.text}>
        <div className={styles.titleRow}>
          <div className={cn("body-small", styles.series)}>
            <Link to={getUrl(series.slug, "products")}>{series.title}</Link>
          </div>

          {title && (
            <h3 className={cn("h4", styles.title)}>
              <Link to={getUrl(slug, "products")}>{title}</Link>
            </h3>
          )}
        </div>

        {(applications || colorTemperature || optical || lumenOutput) && (
          <div className={styles.specs}>
            {applications && (
              <div className={cn("grid", styles.row)}>
                <div className={cn("col-4", styles.key)}>Applications</div>
                <div className={cn("col-8", styles.value)}>{applications}</div>
              </div>
            )}
            {colorTemperature && (
              <div className={cn("grid", styles.row)}>
                <div className={cn("col-4", styles.key)}>Color Temperature</div>
                <div className={cn("col-8", styles.value)}>
                  {colorTemperature}
                </div>
              </div>
            )}
            {optical && (
              <div className={cn("grid", styles.row)}>
                <div className={cn("col-4", styles.key)}>Optical</div>
                <div className={cn("col-8", styles.value)}>{optical}</div>
              </div>
            )}
            {lumenOutput && (
              <div className={cn("grid", styles.row)}>
                <div className={cn("col-4", styles.key)}>Lumen Output</div>
                <div className={cn("col-8", styles.value)}>{lumenOutput}</div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductItem;
